import React from 'react'
import { Hook, makeHook } from '../Hook'
import { createRoot, Root } from 'react-dom/client'
import { GaugeChart } from '../../components/charts/GaugeChart'

class GaugeChartHook extends Hook {
  root?: Root

  mounted() {
    this.root = createRoot(this.el)
    this.render(this.root)
  }

  updated() {
    if (this.root) {
      // If the attributes on the phx-update="ignore" element change,
      // the hook will be re-rendered, so we can use its attributes
      // directly within React.
      this.render(this.root)
    }
  }

  render(root: Root) {
    const props = JSON.parse(this.el.dataset.props || '{}')

    root.render(<GaugeChart {...props} />)
  }
}

export default makeHook(GaugeChartHook)
